import { render, staticRenderFns } from "./FormD.vue?vue&type=template&id=6bf2bcda&scoped=true&"
import script from "./FormD.vue?vue&type=script&lang=js&"
export * from "./FormD.vue?vue&type=script&lang=js&"
import style0 from "./FormD.vue?vue&type=style&index=0&id=6bf2bcda&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf2bcda",
  null
  
)

export default component.exports